

























































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateCountryBill from "./createcountrybill.vue";
import EditCoutryBill from "./editcountrybill.vue";
import CalculatePrice from "./calculateprice.vue";
import SearchTree from "@/lib/Common/searchtree";
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";

class PagePriceRequest extends PageRequest {
  keyword: string;
  areaId: number;
}

@Component({
  components: { CreateCountryBill, EditCoutryBill, CalculatePrice },
})
export default class CountryBills extends AbpBase {
  //检测按钮权限
  checkButtonAuth(tag: string) {
    return checkAuth.CheckButton(tag);
  }
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PagePriceRequest = new PagePriceRequest();
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  searchName: string = "";
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  calculateModalShow: boolean = false; //计算价格
  billId: any[] = []; //已选择国网账单Id
  monthTotalUse: number = 0; //总用量
  monthTotalAmmount: number = 0; //总金额
  month: string = "";
  areaId: number = 0; //园区
  areaName: string = "";
  splitnum: number = 0.15;
  get list() {
    return this.$store.state.countrybills.list;
  }
  get loading() {
    return this.$store.state.countrybills.loading;
  }
  create() {
    this.createModalShow = true;
  }
  //计算基准单价
  calculatePrice() {
    let val = (this.$refs.selection as any).getSelection();
    if (val.length == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("PleasChoose"),
      });
      return;
    }
    this.areaId = 0;
    this.billId = [];
    this.monthTotalUse = 0;
    this.monthTotalAmmount = 0;
    let isone = 1;
    val.forEach((ele) => {
      if (this.areaId > 0 && this.areaId != ele.areaId) {
        isone = 0;
        return;
      }
      this.billId.push(ele.id);
      this.areaId = ele.areaId;
      this.monthTotalUse = this.monthTotalUse + ele.totalUse;
      this.monthTotalAmmount = this.monthTotalAmmount + ele.totalAmmount;
      this.month = ele.timeMonth;
    });
    if (isone == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("DifferentParkNotCalculate"),
      });
      return;
    }
    let ite = JSON.parse(localStorage.getItem("areas"));
    let info = ite.filter((p) => {
      return p.id == this.areaId;
    });
    this.areaName = info.length > 0 ? info[0].fullName : this.L("Unknown");
    this.calculateModalShow = true;
  }
  //改变时间
  changeDate(val) {
    this.pagerequest.keyword = val;
  }
  //左边树触发查找
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.areaId = item[0].id;
    }
    this.$store.commit("countrybills/setCurrentPage", 1);
    this.getpage();
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    this.areaTree = SearchTree.searnchTree(value, treeList);
  }
  //获取区域
  async getAreaTree() {
    await this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  //页改变
  pageChange(page: number) {
    this.$store.commit("countrybills/setCurrentPage", page);
    this.getpage();
  }
  //每页显示
  pagesizeChange(pagesize: number) {
    this.$store.commit("countrybills/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "countrybills/getAll",
      data: this.pagerequest,
    });
  }
  //
  get pageSize() {
    return this.$store.state.countrybills.pageSize;
  }
  get totalCount() {
    return this.$store.state.countrybills.totalCount;
  }
  get currentPage() {
    return this.$store.state.countrybills.currentPage;
  }
  //列名
  columnlist = [
    {
      type: "index",
      width: 70,
      align: "center",
      fixed: "left",
      title: this.L("IndexNo"),
      sortId: 0,
    },
    {
      type: "selection",
      width: 40,
      align: "left",
      fixed: "left",
      sortId: 1,
    },
    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 130,
      resizable: true,
      sortId: 5,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title:
                  info.length > 0 ? info[0].displayName : this.L("Unknown"),
              },
            },
            info.length > 0 ? info[0].displayName : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      title: this.L("Areas"),
      key: "areaId",
      sortable: true,
      width: 200,
      resizable: true,
      fixed: "left",
      sortId: 6,
      render: (h: any, params: any) => {
        let id = params.row.areaId;
        let ite = JSON.parse(localStorage.getItem("areas"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title: info.length > 0 ? info[0].fullName : this.L("Unknown"),
              },
            },
            info.length > 0 ? info[0].fullName : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      title: this.L("Month"),
      key: "timeMonth",
      width: 130,
      fixed: "left",
      sortId: 2,
    },
    {
      title: this.L("TotalUse"),
      key: "totalUse",
      width: 130,
      sortId: 3,
    },
    {
      title: this.L("TotalAmmount"),
      key: "totalAmmount",
      width: 130,
      sortId: 4,
    },
    {
      title: this.L("MD"),
      key: "baseUse",
      width: 130,
      sortId: 4,
    },
    {
      title: this.L("BasePrice"),
      key: "basePrice",
      width: 90,
      sortId: 4,
    },
    {
      title: this.L("BaseAmmount"),
      key: "baseAmmount",
      width: 130,
      sortId: 5,
    },
    {
      title: this.L("TipThisUse"),
      key: "tipUse",
      width: 130,
      sortId: 6,
    },
    {
      title: this.L("TipPrice"),
      key: "tipPrice",
      width: 130,
      sortId: 7,
    },
    {
      title: this.L("TipThisTotalAmmount"),
      width: 130,
      key: "tipAmmount",
      sortId: 8,
    },
    {
      title: this.L("PeakThisUse"),
      key: "peakUse",
      width: 130,
      sortId: 9,
    },
    {
      title: this.L("PeakPrice"),
      key: "peakPrice",
      width: 130,
      sortId: 10,
    },
    {
      title: this.L("PeakThisTotalAmmount"),
      key: "peakAmmount",
      width: 130,
      sortId: 11,
    },
    {
      title: this.L("FlatThisUse"),
      key: "flatUse",
      width: 130,
      sortId: 12,
    },
    {
      title: this.L("FlatPrice"),
      key: "flatPrice",
      width: 130,
      sortId: 13,
    },
    {
      title: this.L("FlatThisTotalAmmount"),
      key: "flatAmmount",
      width: 130,
      sortId: 14,
    },
    {
      title: this.L("ValleyThisUse"),
      key: "valleyUse",
      width: 130,
      sortId: 15,
    },
    {
      title: this.L("ValleyPrice"),
      key: "valleyPrice",
      width: 130,
      sortId: 16,
    },
    {
      title: this.L("ValleyThisTotalAmmount"),
      key: "valleyAmmount",
      width: 130,
      sortId: 17,
    },
    {
      title: this.L("TipBeginingUse"),
      key: "tipBeginUse",
      width: 130,
      sortId: 18,
    },
    {
      title: this.L("TipEndingUse"),
      key: "tipEndUse",
      width: 130,
      sortId: 19,
    },
    {
      title: this.L("PeakBeginingUse"),
      key: "peakBeginUse",
      width: 130,
      sortId: 20,
    },
    {
      title: this.L("PeakEndingUse"),
      key: "peakEndUse",
      width: 130,
      sortId: 21,
    },
    {
      title: this.L("FlatBeginingUse"),
      key: "flatBeginUse",
      width: 130,
      sortId: 23,
    },
    {
      title: this.L("FlatEndingUse"),
      key: "flatEndUse",
      width: 130,
      sortId: 24,
    },
    {
      title: this.L("ValleyBeginingUse"),
      key: "valleyBeginUse",
      width: 130,
      sortId: 25,
    },
    {
      title: this.L("ValleyEndingUse"),
      key: "valleyEndUse",
      width: 130,
      sortId: 26,
    },
    {
      title: this.L("MonthTotalAmmount"),
      key: "monthTotalAmmount",
      width: 130,
      sortId: 26,
    },
    {
      title: this.L("MonthTotalUse"),
      key: "monthTotalUse",
      width: 130,
      sortId: 26,
    },
    {
      title: this.L("BenchmarkPrice"),
      key: "benchmarkPrice",
      width: 130,
      sortId: 26,
    },
    {
      title: this.L("FloatingRange"),
      key: "floatingRange",
      width: 130,
      sortId: 26,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.floatingRange + "%",
            },
          },
          params.row.floatingRange + "%"
        );
      },
    },
    {
      title: this.L("MonthPrice"),
      key: "monthPrice",
      width: 130,
      sortId: 26,
    },
    {
      title: this.L("Description"),
      key: "description",
      width: 130,
      sortId: 28,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.description,
            },
          },
          params.row.description
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      sortId: 30,
      fixed: "right",
      render: (h: any, params: any) => {
        let del = this.checkButtonAuth('countrybillsDel');
        let edit = this.checkButtonAuth('countrybillsEdit');
        return h("div", [
          edit ? h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("countrybills/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ) : '',
          del ? h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "countrybills/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ) : '',
        ]);
      },
    },
  ];
  async created() {
    this.getAreaTree();
    this.getpage();
  }
  data() {
    return {
      meterTypedetail: [],
      useTypedetail: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
